import { render, staticRenderFns } from "./therapeutic.vue?vue&type=template&id=458320fe&scoped=true&"
import script from "./therapeutic.vue?vue&type=script&lang=js&"
export * from "./therapeutic.vue?vue&type=script&lang=js&"
import style0 from "./therapeutic.vue?vue&type=style&index=0&id=458320fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458320fe",
  null
  
)

export default component.exports